import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { 
      main: '#3B82F6', // Vibrant Blue
      light: '#60A5FA',
      dark: '#2563EB',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#8B5CF6', // Vibrant Violet
      light: '#A78BFA',
      dark: '#7C3AED',
      contrastText: '#FFFFFF'
    },
    background: { 
      default: '#0B0F19', // Deep dark space color
      paper: '#131C2D' // Slightly lighter for cards 
    },
    text: { 
      primary: '#F8FAFC',
      secondary: '#94A3B8'
    },
    divider: 'rgba(255, 255, 255, 0.08)'
  },
  shape: { 
    borderRadius: 16 // More rounded corners for premium feel
  },
  typography: {
    fontFamily: [
      'Inter',
      'Outfit',
      '-apple-system',
      'BlinkMacSystemFont',
      'Segoe UI',
      'Roboto',
      'sans-serif'
    ].join(','),
    h1: { 
      fontWeight: 800, 
      letterSpacing: '-0.03em',
      lineHeight: 1.1
    },
    h2: { 
      fontWeight: 700, 
      letterSpacing: '-0.02em',
      lineHeight: 1.2
    },
    h3: { 
      fontWeight: 700,
      letterSpacing: '-0.01em'
    },
    h4: {
      fontWeight: 700
    },
    h5: {
      fontWeight: 600
    },
    h6: {
      fontWeight: 600
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
      letterSpacing: '0.02em'
    }
  },
  components: {
    MuiButton: { 
      styleOverrides: { 
        root: { 
          borderRadius: 12,
          padding: '10px 24px',
          boxShadow: 'none',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-2px)'
          }
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)',
          boxShadow: '0 4px 14px 0 rgba(59, 130, 246, 0.39)',
          '&:hover': {
            boxShadow: '0 6px 20px rgba(59, 130, 246, 0.5)',
            background: 'linear-gradient(135deg, #60A5FA 0%, #3B82F6 100%)',
          }
        },
        outlinedPrimary: {
          border: '1px solid rgba(59, 130, 246, 0.5)',
          '&:hover': {
            border: '1px solid #3B82F6',
            backgroundColor: 'rgba(59, 130, 246, 0.08)'
          }
        }
      } 
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          background: 'rgba(19, 28, 45, 0.6) !important', // glassmorphism base
          backdropFilter: 'blur(12px)',
          border: '1px solid rgba(255, 255, 255, 0.05)',
          boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.3)',
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'rgba(11, 15, 25, 0.7)',
          backdropFilter: 'blur(20px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
        }
      }
    }
  }
});